export const POST_REDIRECT_KEY = 'acp_post_login_redirect_url';
export const POST_REDIRECT_PARAMETERS_KEY =
  'acp_post_login_redirect_parameters';

/**
 * Records the pathname on which this tab has already spent its single
 * Spectrum-interop reload. Backed by sessionStorage because `location.reload()`
 * destroys all in-memory state, so a loop breaker has to outlive the document.
 */
export const SPECTRUM_INTEROP_RELOAD_KEY = 'acp_spectrum_interop_reload';
